import { createTheme } from '@mui/material/styles';

import GothamBold from './fonts/GothamBold.ttf';
import GothamBook from './fonts/GothamBook.ttf';
import GothamLight from './fonts/GothamLight.ttf';
import GothamMedium from './fonts/GothamMedium.ttf';

const getPaletteMode = (mode) => {
  return mode === 'light'
    ? {
        primary: { main: '#5D5957' },
        secondary: { main: '#666873' },
        background: {
          default: '#FEFEFE',
          paper: '#F6F6F4',
          backdrop: 'rgba(255,255,255,0.8)'
        },
        accent: { main: '#CB6423' },
        text: { main: '#2A3242', light: '#FEFEFE' }
      }
    : {
        primary: { main: '#383435' },
        secondary: { main: '#666873' },
        background: {
          default: '#888583',
          paper: '#2A2627'
        },
        accent: { main: '#CB6423' },
        text: { main: '#ffffff' }
      };
};

const createFairtreeTheme = (mode) => {
  const palette = getPaletteMode(mode);

  return createTheme({
    palette,

    typography: {
      fontFamily: 'Verdana',
      htmlFontSize: 18,

      body1: {
        fontSize: '0.8rem',
        fontFamily: 'Verdana'
      },

      subtitle1: {
        fontSize: '0.65rem',
        fontWeight: 500,
        color: palette.secondary.main,
        lineHeight: 1.2,
        fontFamily: 'Verdana'
      },

      subtitle2: {
        fontSize: '0.9rem',
        fontWeight: 500,
        fontFamily: 'Verdana'
      },

      h1: {
        fontSize: '2.5rem',
        fontFamily: 'Verdana'
      },

      h2: {
        fontSize: '2rem',
        fontFamily: 'Verdana'
      },

      h3: {
        fontSize: '1.7rem',
        fontFamily: 'Verdana'
      },

      h4: {
        fontSize: '1.4rem',
        fontFamily: 'Verdana'
      },

      h5: {
        fontSize: '1rem',
        fontWeight: 700,
        fontFamily: 'Verdana'
      },

      h6: {
        fontSize: '0.9rem',
        fontWeight: 400,
        fontFamily: 'Verdana'
      },

      headingText: {
        fontFamily: "'Times New Roman', serif",
        fontWeight: 'bold'
      }
    },

    shape: {
      borderRadius: 0
    },

    components: {
      MuiTypography: {
        variants: [
          {
            props: { variant: 'headingText' },
            style: {
              fontFamily: "'Times New Roman', serif",
              fontWeight: 700,
              lineHeight: 1.2
            }
          },
          {
            props: { color: 'accent' },
            style: {
              color: palette.accent.main
            }
          }
        ],

        styleOverrides: {
          root: {
            '&.MuiTypography-colorAccent': {
              color: palette.accent.main
            }
          }
        }
      },

      MuiCssBaseline: {
        styleOverrides: `
          @font-face {
            font-family: 'Gotham';
            font-style: normal;
            font-display: swap;
            font-weight: 200;
            src: url(${GothamLight}) format('truetype');
          }

          @font-face {
            font-family: 'Gotham';
            font-style: normal;
            font-display: swap;
            font-weight: 400;
            src: url(${GothamBook}) format('truetype');
          }

          @font-face {
            font-family: 'Gotham';
            font-style: normal;
            font-display: swap;
            font-weight: 500;
            src: url(${GothamMedium}) format('truetype');
          }

          @font-face {
            font-family: 'Gotham';
            font-style: normal;
            font-display: swap;
            font-weight: 600;
            src: url(${GothamBold}) format('truetype');
          }

          /* ================================
             FIX FOR MUI PICKER MONTHS/YEAR
          ================================= */

          button.PrivatePickersMonth-root:disabled {
            color: #bdbdbd !important;
            opacity: 1 !important;
          }

          button.PrivatePickersMonth-root {
            font-size: 0.85rem;
          }

          button.PrivatePickersMonth-root.Mui-selected {
            background-color: #424242;
            color: #fff;
            border-radius: 18px;
          }

          button.PrivatePickersMonth-root:hover {
            background-color: #e0e0e0;
          }

          button.PrivatePickersMonth-root:disabled:hover {
            background-color: transparent !important;
          }
        `
      },

      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: palette.background.paper,
            color: palette.text.main
          }
        }
      },

      MuiDivider: {
        styleOverrides: {
          root: {
            borderColor: '#E5E5E5'
          }
        }
      },

      MuiDialog: {
        styleOverrides: {
          paper: {
            boxShadow: 'none'
          }
        }
      }
    }
  });
};

export { createFairtreeTheme };
